import type { ReactNode } from 'react'
import { useFieldContext } from '@/lib/form-contexts'
import { Slider, type SliderProps } from '../ui/slider'
import { cn } from '@/lib/utils'
import { Label } from '../ui/label'
import { useIsReadOnly } from '@/lib/casl'

export type SliderInputProps = Omit<SliderProps, 'value' | 'onValueChange'> & {
  label?: ReactNode
  unit?: string
}

// The slider primitive reports its thumbs as an array; this adapter keeps one numeric value.
const SliderInput = ({
  className,
  step,
  min,
  max,
  label,
  unit,
  disabled,
  ...props
}: SliderInputProps) => {
  const field = useFieldContext<number>()
  const { isReadOnly } = useIsReadOnly()

  const handleChange = (value: number[]) => {
    const [nextValue] = value
    if (nextValue !== undefined) field.handleChange(nextValue)
  }
  return (
    <div className="flex flex-col w-full gap-3">
      <div className="flex items-center justify-between gap-2">
        {label && <Label htmlFor={field.name}>{label}</Label>}
        <span className="text-muted-foreground text-sm">
          {field.state.value}
          {!!unit && ` ${unit}`}
        </span>
      </div>
      <Slider
        className={cn('w-full', className)}
        id={field.name}
        step={step}
        min={min}
        max={max}
        disabled={isReadOnly || disabled}
        value={[field.state.value]}
        onValueChange={handleChange}
        {...props}
      />
    </div>
  )
}

export default SliderInput
